<template>
  <div
    class="flex items-center justify-center w-full min-h-screen bg-slate-500"
  >
    <div class="max-w-2xl w-full p-5 mx-auto prose bg-white mb-[30vh]">
      <div v-if="back" class="mb-4">
        <router-link
          :to="{ name: back.toName }"
          class="flex items-center space-x-1"
        >
          <ArrowLeftIcon class="w-5 h-5" />
          <span class="block">
            {{ back.name }}
          </span>
        </router-link>
      </div>
      <h1>{{ title }}</h1>
      <ul>
        <li v-for="link in links" :key="link.toName">
          <router-link :to="{ name: link.toName }">
            {{ link.name }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ArrowLeftIcon } from "@heroicons/vue/20/solid";

defineProps<{
  title: string;
  links: { toName: string; name: string }[];
  back?: { toName: string; name: string };
}>();
</script>
